import React from 'react';
import { withProps, compose } from 'recompose';
import { LineHeightTool } from '@nextiva/rich-text-editor';
import withRichTextSelectToolStyles from '../../../hoc/withRichTextSelectToolStyles';
import LineHeightTextEditorToolToggle from '../LineHeightTextEditorToolToggle';

import styles from './LineHeightTextEditorTool.scss';

export default compose(
  withProps({
    className: styles.tool,
    valueRenderer: () => <LineHeightTextEditorToolToggle />,
    placeholder: <LineHeightTextEditorToolToggle />,
  }),
  withRichTextSelectToolStyles,
)(LineHeightTool);
